import React from 'react';
import { Link } from 'react-router-dom';
import './AppLogo.css';

const AppLogo = () => (
  <Link className="AppLogo" to="/">
    <span></span>
    <span>PHOENIX</span>
  </Link>
);

export default AppLogo;



// WEBPACK FOOTER //
// ./src/main/components/AppLogo.js